import { render, staticRenderFns } from "./quotaAccountLog.vue?vue&type=template&id=2bb9956e&scoped=true"
import script from "./quotaAccountLog.vue?vue&type=script&lang=js"
export * from "./quotaAccountLog.vue?vue&type=script&lang=js"
import style0 from "./quotaAccountLog.vue?vue&type=style&index=0&id=2bb9956e&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb9956e",
  null
  
)

export default component.exports